// extracted by mini-css-extract-plugin
module.exports = {"card":"skills-module--card--1deUD","card__header":"skills-module--card__header--3XsBu"};